import { useState } from "react";
import { useTranslations } from "use-intl";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import InstallmentBreakdownDrawer from "@/app/ui/flight-purchase/InstallmentBreakdownDrawer";
import { useLocaleInfo } from "@/app/lib/hooks/useLocaleInfo";
import { formatCurrency } from "@/app/lib/utils/currency";
import { usePaymentContext } from "@/app/lib/context/PaymentContext";

interface InstallmentDetailsProps {
  totalPrice: number;
}

const InstallmentDetails = ({ totalPrice }: InstallmentDetailsProps) => {
  const t = useTranslations();
  const [showBreakdown, setShowBreakdown] = useState(false);
  const { locale } = useLocaleInfo();
  const { selectedInstallments } = usePaymentContext();
  const nextMonth = dayjs().add(1, "month").locale(locale).format("MMMM");

  return (
    <>
      <div className="section-card mt-2 flex flex-col gap-2 text-sm">
        <div className="flex justify-between">
          <span className="text-text-tertiary">
            {t("instalmentDetails.nextPayment")}
          </span>
          <span className="font-bold text-text-primary">{nextMonth}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-text-tertiary">
            {t("instalmentDetails.paymentAmount")}
          </span>
          <span dir="ltr" className="font-bold text-text-primary">
            {t("instalmentDetails.paymentAmountValue", {
              amount: formatCurrency(totalPrice / selectedInstallments),
            })}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-text-tertiary">{t("flights.totalPrice")}</span>
          <span className="font-bold text-text-primary">
            {formatCurrency(totalPrice)}
          </span>
        </div>
        <Button
          color="primary"
          variant="outlined"
          size="small"
          onClick={() => setShowBreakdown(true)}
          sx={{ marginTop: 1 }}
        >
          {t("instalmentDetails.moreDetails")}
        </Button>
      </div>
      <InstallmentBreakdownDrawer
        totalPrice={totalPrice}
        open={showBreakdown}
        onClose={() => setShowBreakdown(false)}
      />
    </>
  );
};

export default InstallmentDetails;
